import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "providerapp/pagination";
import {ImportUserRequestInfo} from "../domain/types";

export type ImportUserRequestListAction =
    | { type: 'SET_REFRESH_FUNC', refetchFunc: VoidFunction }
    | { type: 'SET_SHOW_DETAIL', selected: ImportUserRequestInfo }
    | { type: 'SET_HIDE_DETAIL' }
    | RelayPaginationActionPayload;


export interface ImportUserRequestListState {
    showDetailModal: boolean;
    refetchFunc: VoidFunction | null;
    selected: ImportUserRequestInfo | null;
    pagination: RelayPaginationState;
}

export function initState(): ImportUserRequestListState {
    return {
        pagination: new RelayPaginationState('0', 8),
        refetchFunc: null,
        showDetailModal: false,
        selected: null
    };
}

export function importUserRequestListReducer(
    state: ImportUserRequestListState,
    action: ImportUserRequestListAction,
): ImportUserRequestListState {
    switch (action.type) {
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'SET_SHOW_DETAIL':
            return {
                ...state,
                showDetailModal: true,
                selected: action.selected
            }
        case 'SET_HIDE_DETAIL':
            return {
                ...state,
                showDetailModal: false
            }
        case 'SET_REFRESH_FUNC':
            return {
                ...state,
                refetchFunc: action.refetchFunc
            }
    }
}
